import UserModel from '$gbusiness/models/user';
import StoreModel from './store';

export default interface CurrentStateModel {
  factoryId: number;
  hidePrice: boolean;
  isLoggedIn: boolean;
  ebrochure: boolean;
  isWholesale?: boolean;
  settings?: any;
  isFactory?: boolean;
  isGuest?: boolean;
  isSalesman?: boolean;
  user?: UserModel;
  store?: StoreModel;
}

export const getUserLevelFromState = (currentState) => {
  if (!currentState || !currentState.user) return 4;
  return currentState.user?.userLevel === 0 ? 0 : currentState.user?.userLevel || 3;
};

export const getUserLevel = (user) => {
  if (!user) return 4;
  return user?.userLevel === 0 ? 0 : user?.userLevel || 4;
};

export const initialCurrentState: CurrentStateModel = {
  factoryId: 0,
  hidePrice: true,
  isLoggedIn: false,
  isWholesale: false,
  ebrochure: true,
};
